<template>
  <div>
    <b-card no-body>
      <div class="card-smallHeader">
        <i class="fa fa-justify mr-2"></i>
        <strong>Tableau des résultats</strong>
      </div>
      <b-card-body class="xsmall-padding">
        <v-server-table @loaded="onLoaded" ref="table" :columns="columns" :url="url" :options="options"
                        style="overflow: hidden;">
          <div slot="source" slot-scope="props" @click.prevent="showDossier(props.row)" class="clickable">
            <b>{{ props.row.id }}</b> <br> {{ props.row.canal.libelle }}
          </div>
          <div slot="date_reception" slot-scope="props" @click.prevent="showDossier(props.row)" class="clickable">
            <span :id="'tooltip-detail-sinistre-'+props.row.id" class="text-center"><b>{{ formatDate(props.row.date_reception) }}</b><img
              class="pull-right" v-if="hasTooltipDetailSinistre(props.row)" :src="getIconSrc('corner')"></i></span>
            <b-tooltip v-if="hasTooltipDetailSinistre(props.row)"  :target="'tooltip-detail-sinistre-'+props.row.id" triggers="hover" custom-class="pre-formatted" placement="right">
              <ul class="ul-tooltip">
                <li>{{ formatDate(props.row.date_debut_periode) }} au {{ formatDate(props.row.date_fin_periode) }} - {{ props.row.montant_ij_ss }} €</li>
              </ul>
            </b-tooltip>
          </div>
          <div slot="date_affectation" slot-scope="props" class="clickable">
            <div :id="`tooltip-equipe-${props.row.id}`" v-html="getDateAffectation(props.row)" ></div>
            <b-tooltip :target="`tooltip-equipe-${props.row.id}`" triggers="hover" placement="right">
              <span><span style="color:#EFEFEF;">EQUIPE : </span> <b>{{ getEquipe(props.row) }}</b></span>
            </b-tooltip>
          </div>
          <div slot="dossier_type" slot-scope="props" @click.prevent="showDossier(props.row)" class="clickable">
            <span>{{ getInfosType(props.row)}}</span><br>
            <span v-b-tooltip.hover :title="getLibelleTraitement(props.row,'long')" :style="getFontColor(props.row)">{{ getLibelleTraitement(props.row,'court') }}<img
              class="pull-right" :src="getIconSrc('corner')"></span>
          </div>
          <div slot="siren" slot-scope="props" @click.prevent="showDossier(props.row)" class="clickable">
            <b :id="`tooltip-siren-${props.row.id}`" style="color: rgb(217, 65, 139);">{{ props.row.siren ? props.row.siren.siren : 'n.d' }}</b><br>
            <!-- <b :id="`tooltip-siren-${props.row.id}`" style="color: rgb(217, 65, 139);">{{ getSiret(props.row) }}</b><br> -->
            <span class="text-success" :id="`tooltip-rs-${props.row.id}`">{{ props.row.siren ? (props.row.siren.raison_sociale.length > 42 ? props.row.siren.raison_sociale.substring(0,39) + '...' : props.row.siren.raison_sociale) : 'n.d' }}</span>
            <b-tooltip v-if="props.row.siren" :target="`tooltip-siren-${props.row.id}`" triggers="hover" placement="right">
              <span v-if="props.row.nic"><span style="color: #EFEFEF;">SIRET : </span> <b>{{props.row.siren.siren + props.row.nic }}</b><br></span>
              <span style="color: #EFEFEF;">OAG : </span> <b>{{ props.row.oag }}</b> <span style="color: #EFEFEF;"> OAP : </span><b> {{ props.row.oap }}</b>
            </b-tooltip>
            <b-tooltip v-if="props.row.siren && props.row.siren.raison_sociale.length > 42" :target="`tooltip-rs-${props.row.id}`" triggers="hover" placement="right">{{ props.row.siren.raison_sociale }}</b-tooltip>
          </div>
          <div slot="produit" slot-scope="props" @click.prevent="showDossier(props.row)" class="clickable" v-html="getInfosSegmentProduit(props.row)">
          </div>
          <div slot="nom" slot-scope="props" @click.prevent="showDossier(props.row)" class="clickable">
            <b style="color: #990000;">{{ props.row.nir ? formatNir(props.row.nir) : 'n.d' }}</b><br>
            <span class="">{{ props.row.nom ? props.row.nom.toUpperCase()+' '+props.row.prenom : (props.row.nom_naissance ? props.row.nom_naissance.toUpperCase()+' '+props.row.prenom : 'n.d') }}</span>
          </div>
          <div slot="nb_pj" slot-scope="props" @click.prevent="showDossier(props.row)" class="clickable">
            <span :id="'tooltip-pj-'+props.row.id" class="text-center"><b>{{ props.row.pieces_jointes.length }}</b><img
              class="pull-right" :src="getIconSrc('corner')"></i></span>
            <b-tooltip v-if="props.row.pieces_jointes.length > 0" :target="'tooltip-pj-'+props.row.id" triggers="hover" custom-class="pre-formatted" placement="left">
              <ul class="ul-tooltip">
                <li style="white-space: nowrap;" v-for="pj of props.row.pieces_jointes">{{ pj.source === 'mail' ? pj.dossier_id : pj.source_id }} |
                  {{ formatDate(pj.date_reception)+' | '+pj.name+' | ' }}{{ pj.source !== 'gestionnaire' ? 'client' :
                  'interne' }}
                </li>
              </ul>
            </b-tooltip>
            <br>
            <span>{{ getIndication(props.row) }}</span>
          </div>
          <div slot="status" slot-scope="props" @click.prevent="showDossier(props.row)" class="clickable" v-html="getInfosStatus(props.row)">
          </div>
          <div slot="date_objectif" slot-scope="props" @click.prevent="showDossier(props.row)" class="clickable row-content" v-html="getInfosDateObjectif(props.row)">
          </div>
          <div slot="notes" slot-scope="props" class="text-center">
            <span :id="'tooltip-note-'+props.row.id" class="text-center">
              <img class="clickable" :src="getIconSrc('post-it', props.row)" @click="editCommentaire(props.row)">
            </span>
            <b-tooltip v-if="props.row.commentaires_gestion.length > 0" :target="'tooltip-note-'+props.row.id" triggers="hover" custom-class="pre-formatted" placement="left">
              <ul class="ul-tooltip">
                <li v-for="commentaire of props.row.commentaires_gestion">
                  {{ commentaire.texte }}
                </li>
              </ul>
            </b-tooltip>
          </div>
          <div slot="action" slot-scope="props">
            <router-link v-if="getSrc(props.row)" :to="getSrc(props.row)" class="badge badge-primary p-2"><i class="fa fa-search" title="Voir le dossier"></i></router-link>
          </div>
          <div slot="selection" slot-scope="props">
            <b-form-checkbox v-model="selectedRows" :value="props.row.id"
                             :state="errors.checkbox === ''"></b-form-checkbox>
          </div>
          <div slot="h__selection">
            <!-- <input type="checkbox" name="selected" @click="selectAll()"> -->
            <b-form-checkbox
              v-model="allSelected"
              :indeterminate="indeterminate"
              aria-describedby="items"
              aria-controls="items"
              @change="toggleAll"
            >
            </b-form-checkbox>
          </div>

          <div slot="afterTable">
            <b-row>
              <b-col sm="12">
                <span class="field-error inline mr-1 float-right">{{ errors.checkbox }}</span>
                <span class="field-error inline mr-1 float-right">{{ errors.checkboxFusion }}</span>
                <span class="field-error inline mr-1 float-right pre-formatted">{{ errors.fusion }}</span>
              </b-col>
            </b-row>
            <b-row>
              <b-col sm="12">
                <div style="float: right;display: inline-block;" v-if="canShowActionBar">
                  <b-button v-if="canAffecte('autoAffecte')" type="button" @click="launchAffectation('autoAffecte')" title="S'Auto-Affecter les dossiers pour traitement" class="pull-right ml-1 mr-1 mt-1" size="md" variant="success">
                    <i class="fa fa-arrow-right"></i><i class="fa fa-user"></i> Auto-Affecter
                  </b-button>
                  <b-button v-if="showAffect('affecte')" type="button" @click="launchAffectation('affecte')" title="Affecter les dossiers pour traitement" class="pull-right ml-1 mr-1 mt-1"
                            size="md" variant="primary">
                    <i class="fa fa-arrow-right"></i><i class="fa fa-user-o"></i> Affecter
                  </b-button>
                  <b-button v-if="canAffecte()" type="button" @click="desaffectation()" title="Désaffecter les dossiers pour traitement" class="pull-right ml-1 mr-1 mt-1"
                            size="md" variant="warning">
                    <i class="fa fa-eraser"></i> Désaffecter
                  </b-button>
                  <b-button v-if="canDoMerge()" type="button" @click="fusion()" class="pull-right ml-1 mr-1 mt-1" size="md"
                            variant="success">
                    <i class="fa fa-sitemap fa-rotate-180" title="Affecter les dossiers pour traitement"></i> Fusionner
                  </b-button>
                  <span v-if="canDoMerge() || canAffecte('autoAffecte')" class="pull-right ml-2 mr-2" style="border-right:2px solid grey; display:inline-block;height:35px;margin-top:5px"></span>
                  <b-button v-if="canSetDossierUrgent()" type="button" @click="setDossierUrgent()" class="pull-right ml-1 mr-1 mt-1" size="md"
                            variant="danger">
                    <i class="fa fa-warning" title="Passer en urgence direction"></i> Urgences Dossiers
                  </b-button>
                </div>
                <div>
                  <b-button type="button" @click="exportResultat()" class="export-excel-btn mb-2" size="md">
                    <i class="fa fa-file-excel-o"></i>&nbsp; Exporter en Excel
                  </b-button>
                </div>
              </b-col>
            </b-row>
          </div>
        </v-server-table>
      </b-card-body>
    </b-card>
    <!-- </div> -->
    <b-modal centered id="modal-affectation" ref="modal-affectation" title="Affectation des dossiers à un gestionnaire">
      <auto-select
        v-model="gestionnaireGestion"
        :items="gestionnairesGestion"
        :loading="loadingGestionnaire"
        item-value="id"
        item-text="nom"
        menuDefaultPosition="top"
        :placeholder="gestionnaireGestion ? '' : 'Entrer le nom du gestionnaire'"
        disable-filtering-by-search
        @search="onSearchGestionnaireGestion"
        style="display: inline-block;"
        class="w-100"
        :class="{hasError: errors.gestionnaire !== ''}"
      >
        <template #no-data>
          {{ noData ? "Aucun gestionnaire trouvé." : "Il faut au moins 2 caractères pour la recherche." }}
        </template>
        <template slot="item" slot-scope="{ item: gest }">
          <div style="display: flex; align-items: center;">
            <span class="item-name"> {{ gest.nom }} {{ gest.prenom }} </span>
          </div>
        </template>
        <template slot="selection" slot-scope="{ item: gest }">
          <div style="display: flex; align-items: center;">
            <span class="item-name"> {{ gest.nom }} {{ gest.prenom }} </span>
          </div>
        </template>
        <template v-if="loadingGestionnaire" #input-end>
          <img src="https://i.imgur.com/mTNe6tr.gif" class="loading-indicator">
        </template>
      </auto-select>
      <span class="field-error d-block mr-1 ">{{ errors.gestionnaire }}</span>
      <span class="field-error d-block mr-1 ">{{ errors.checkbox }}</span>
      <b-form-checkbox v-model="affectationProlongationOnly" name="check-button" switch class="col-md-12 mt-3">
        Ne pas affecter les dossiers qui ont des ouvertures
      </b-form-checkbox>
      <template v-slot:modal-footer>
        <div class="w-100 text-right">
          <button type="button" class="btn btn-secondary mr-1" @click="closeModalAffectation()">Annuler</button>
          <button type="button" @click="hasManageDossier" class="btn btn-primary"><i class="fa fa-save"></i>
            Enregistrer
          </button>
        </div>
      </template>
    </b-modal>

    <b-modal size="xl" scrollable id="modal-commentaire" ref="modal-commentaire" title="Commentaires sur le dossier">
      <b-row v-for="(commentaire,key) of commentairesGestion" class="align-items-center" :key="commentaire.id">
        <b-col md="10" style="display: inline-block;">
          <label>Commentaire
            <span class="smaller-2">
              <i>Dernière modification le {{ formatDateHeure(commentaire.updated_at) }}
                par <span v-if="commentaire.gestionnaire != null">{{ commentaire.gestionnaire.prenom }} {{ commentaire.gestionnaire.nom }}</span>
                <span v-else> Système </span>
              </i>
            </span>
          </label>
          <b-form-textarea
            :id="'commentaire-'+commentaire.id"
            v-model="commentaires[commentaire.dossier_id][commentaire.id].texte"
            placeholder="Saisir un commentaire..."
            rows="3"
            max-rows="6"
            :class="{hasError: errors.commentaire !== '' && commentaires[commentaire.dossier_id][commentaire.id].texte === ''}"
            :disabled="commentaire.user_id === 999999 || cantEditFicheDC()">
          </b-form-textarea>
        </b-col>
        <b-col md="2" class="align-middle" :hidden="cantEditFicheDC()">
          <b-form-checkbox v-model="commentaires[commentaire.dossier_id][commentaire.id].is_urgent" name="check-button"
                           switch> Urgent
          </b-form-checkbox>
          <b-form-checkbox v-model="commentaires[commentaire.dossier_id][commentaire.id].is_relation_client" name="check-button"
                           switch> Relation Client
          </b-form-checkbox>
          <i class="fa fa-trash fa-1_5x mt-1 text-danger clickable" v-if="canDeleteCommentaire(commentaire)" v-b-tooltip.hover title="Supprimer le commentaire"
          @click="deleteCommentaire(commentaire)"></i>
        </b-col>
      </b-row>
      <b-row>
        <b-col md="12">
          <button v-if="addComHidden" type="button" title="Ajouter un commentaire"
                  class="btn btn-succes mr-1  pull-right" @click="addComHidden = false" :hidden="cantEditFicheDC()"><i
            class="fa fa-plus-circle fa-2x green" aria-hidden="true"></i></button>
        </b-col>
      </b-row>
      <b-row v-if="!addComHidden">
        <b-col md="10">
          <b-card no-body class="mt-3">
            <div class="card-smallHeader">
              <i class="fa fa-justify mr-2"></i>
              <strong>Ajouter un commentaire</strong>
            </div>
            <b-card-body>
              <b-form-group>
                <b-form-textarea
                  v-model="commentaireToAdd"
                  placeholder="Saisir un commentaire..."
                  rows="3"
                  max-rows="6"
                  :class="{hasError: errors.commentaire !== '' && commentaireToAdd === '' && (isUrgentToAdd === true || isRelationClientToAdd === true)}"
                ></b-form-textarea>
              </b-form-group>
              <b-form-group class="align-middle">
                <b-form-checkbox v-model="isUrgentToAdd" name="check-button" switch> Urgent</b-form-checkbox>
              </b-form-group>
              <b-form-group class="align-middle">
                <b-form-checkbox v-model="isRelationClientToAdd" name="check-button" switch> Relation Client</b-form-checkbox>
              </b-form-group>
            </b-card-body>
          </b-card>
        </b-col>
      </b-row>
      <span class="field-error inline mr-1 float-right">{{ errors.commentaire }}</span>
      <template v-slot:modal-footer>
        <div class="w-100 text-right">
          <button type="button" class="btn btn-secondary mr-1" @click="closeModal()">Annuler</button>
          <button type="button" @click="saveCommentaire()" class="btn btn-primary" :hidden="cantEditFicheDC()"><i class="fa fa-save"></i>
            Enregistrer
          </button>
        </div>
      </template>
    </b-modal>
  </div>
</template>

<script>
  import {getBaseUrl, getProvider, getIdToken, getAccessToken, getUser, hasHabilitationOagOapDossier} from "@/utils/auth";
  import {hasRule, espaceGestionRules as rules} from "@/utils/rulesHelper";
  import moment from 'moment';
  import {CoolSelect as AutoSelect} from 'vue-cool-select';
  import {downloadFile, isEmpty} from "@/utils/fileHelper";
  import {isResponsable, getUserTraitementIds} from "@/utils/userHelper";
  import {getMainTreatmentBasedOnType} from "@/utils/communHelper";
  import {replaceDotToComma} from "@/utils/communHelper";
  import {getIconPostit, cantEditFicheDC} from "@/utils/communHelper";

  export default {
    name: "ContactTable",
    props: ["tableEntry"],
    components: {
      AutoSelect,
    },
    data() {
      let self = this;
      return {
        canShowActionBar: true,
        replaceDotToComma,
        gestionnaireGestion: '',
        gestionnairesGestion: [],
        allTreatment: [],
        loadingGestionnaire: false,
        timeoutId: null,
        noData: false,
        url: '',
        data: [],
        findDossiers: [],
        allSelected: [],
        selectedRows: [],
        indeterminate: false,
        columns: [],
        items: [],
        sujets: [],
        commentaires: {},
        commentairesOriginaux: [],
        commentairesGestion: [],
        dossierIdForCommentaire: '',
        commentaireToAdd: '',
        isUrgentToAdd: false,
        isRelationClientToAdd: false,
        addComHidden: true,
        options: {
          headings: {
            'date_reception': 'Date de\nréception',
            'source': 'N° dossier\nCanal récept.',
            'date_affectation': 'Date d\'\naffectation\nNom gestionnaire',
            'dossier_type': 'Type dossier\nTraitement',
            'siren': 'SIREN\nRaison Sociale',
            'produit': 'Segment\nProduit',
            'nom': 'NIR\nNom Prénom',
            'nb_pj': 'Nb. pj\nIndication',
            'status': 'Statut\nSous-statut',
            'date_objectif': 'Date objectif\nNb jours restants',
            // 'delai': 'Délai\nAlerte',
            'notes': 'Notes',
            'action': '#',
            'selection': ''
          },
          columnsClasses: {
            nb_pj: 'pre-formatted tooltip-cell position-r',
            dossier_type: 'pre-formatted tooltip-cell sort-top position-r',
            siren: 'pre-formatted sort-top position-r',
            produit: 'pre-formatted sort-bottom position-r',
            nom: 'pre-formatted sort-bottom min-width-nir position-r',
            date_objectif: 'pre-formatted',
            // delai: 'pre-formatted position-r',
            status: 'pre-formatted position-r',
            source: 'pre-formatted sort-top position-r',
            date_reception: 'pre-formatted sort-middle position-r tooltip-cell',
            date_affectation: 'pre-formatted sort-top position-r',
            action: 'align-middle action-xs text-center position-r',
            selection: 'align-middle text-center position-r',
            notes: 'align-middle action-xs position-r'
          },
          cellClasses:{
            source: [{
              class:'dossier-prioritaire-urgences-directions',
              condition: row => row.type_urgence === 'urgences_directions'
            },
            {
              class:'dossier-prioritaire-lignes-rouges',
              condition: row => row.type_urgence === 'lignes_rouges'
            },
            {
              class:'dossier-prioritaire-fiche-tel',
              condition: row => row.type_urgence === 'fiche_telephonique'
            },
            {
              class:'dossier-prioritaire-mog',
              condition: row => row.type_urgence === 'mog'
            }
            ],
          },
          rowClassCallback(row) {
            let traitementId = null;
            if (isEmpty(self.$parent.traitementId)) {
              traitementId = self.getTraitementId(row);
            } else {
              traitementId = self.$parent.traitementId;
            }
            return 'row_dossier_' + row.id + '_' + traitementId;
            // return 'row_dossier_' + row.id + ' color_traitement_' + traitementId;
          },
          sortable: ['source', 'date_reception', 'date_affectation', 'dossier_type', 'siren', 'produit', 'nom', 'notes'],
          filterable: false,
          resizableColumns: true,
          perPage: 10,
          perPageValues: [10, 20, 50, 100],
          orderBy: {column: 'date_reception', ascending: true},
          requestFunction: function (data) {
            self.url = '/espaceGestion/dossier/recherche'
            data['fromDashboard'] = self.$parent.fromDashboard
            data['balId'] = self.$parent.balId
            data['basketId'] = self.$parent.basketId
            data['statusId'] = self.$parent.selectedSousStatus.length > 0 ? self.$parent.selectedSousStatus : self.$parent.selectedStatus
            data['nir'] = self.$parent.nir
            data['id_pp'] = self.$parent.idpp
            data['gestionnaire'] = self.$parent.gestionnaire
            data['date_du'] = self.$parent.date_du
            data['date_au'] = self.$parent.date_au
            data['date_sinistre_du'] = self.$parent.date_sinistre_du
            data['date_sinistre_au'] = self.$parent.date_sinistre_au
            data['siren'] = self.$parent.siren
            data['nom'] = self.$parent.nom
            data['prenom'] = self.$parent.prenom
            data['rar'] = self.$parent.rar
            data['numero_evenement_nsi'] = self.$parent.numeroEvenementNsi
            data['dossierIds'] = self.$parent.dossierIds
            data['segment'] = self.$parent.selectedSegments
            data['canal'] = self.$parent.selectedCanals
            data['type'] = self.$parent.selectedTypes
            data['produit'] = self.$parent.selectedProduits
            data['status_prestij'] = self.$parent.selectedStatusPrestij
            data['segmentsCommerciaux'] = self.$parent.selectedSegmentsCommerciaux
            data['delegations'] = self.$parent.selectedDelegations
            data['group_siren'] = self.$parent.selectedGroupSirens
            data['campagnes'] = self.$parent.selectedCampagnes
            data['oags'] = self.$parent.selectedOags
            data['oaps'] = self.$parent.selectedOaps
            data['selectedTeam'] = self.$parent.selectedTeam
            data['traitementId'] = self.$parent.selectedTraitementId
            // data['traitementId'] = self.$parent.traitementId
            data['statusTraite'] = self.$parent.statusTraite
            data['modeVisualisation'] = self.$parent.modeVisualisation
            data['alerte'] = self.$parent.alerte
            data['noSearch'] = self.$parent.noSearch
            data['forExport'] = false
            // data['onlyNir'] = self.$parent.onlyNir
            // data['onlyDossier'] = self.$parent.onlyDossier
            data['typeUrgence'] = self.$parent.selectedTypesUrgences
            data['onlyOneCritere'] = self.$parent.onlyOneCritere
            data['contactEmail'] = self.$parent.contactEmail
            data['regleCumul'] = self.$parent.regleCumul
            data['nomBeneficiaire'] = self.$parent.nomBeneficiaire
            data['nbDossierNir'] = self.$parent.nbDossierNir
            data['exclureBpij'] = self.$parent.exclureBpij
            data['flag'] = self.$parent.selectedFlags
            data['typePopulation'] = self.$parent.typePopulation
            data['typeAffiliationSalarie'] = self.$parent.typeAffiliationSalarie
            data['codesPtz'] = self.$parent.selectedCodePtz
            data['exclureGroupeSiren'] = self.$parent.exclureGroupeSiren
            data['exclureDateSinistre'] = self.$parent.exclureDateSinistre

            if (self.$parent.noSearch !== 'noSearch') {
              self.$store.commit('IS_LOADING', true);
            }

            return axios.get(self.url, {
              params: data
            })
              .then(function (response) {
                if (self.$parent.noSearch !== 'noSearch') {
                  self.$store.commit('IS_LOADING', false);
                }
                self.findDossiers = response.data.data;
                // console.log('dossiers :',self.findDossiers)
                self.searchData = data;
                self.excelData = [];
                self.commentaires = {};
                self.commentairesOriginaux = []; // Pour la gestion d'une modification d'un commentaire existant et le clique sur annuler, pour pouvoir revenir aux données originales
                for (let dossier of response.data.data) {
                  self.commentaires[dossier.id] = {}
                  self.commentairesOriginaux[dossier.id] = []
                  for (let commentaire of dossier.commentaires_gestion) {
                    self.commentaires[dossier.id][commentaire.id] = {
                      texte: commentaire.texte,
                      is_urgent: commentaire.is_urgent,
                      is_relation_client: commentaire.is_relation_client
                    }
                    self.commentairesOriginaux[dossier.id][commentaire.id] = {
                      texte: commentaire.texte,
                      is_urgent: commentaire.is_urgent,
                      is_relation_client: commentaire.is_relation_client
                    }
                  }
                  if (self.commentaires[dossier.id] === undefined) {
                    self.commentaires[dossier.id] = {}
                    self.commentairesOriginaux[dossier.id] = []
                  }
                }
                return response;
              })
              .catch(function (e) {
                console.log(e)
                self.$store.commit('IS_LOADING', false)
                self.$swal({
                  position: 'top',
                  type: 'error',
                  title: 'Attention !!',
                  text: 'Une erreur est survenue, si le problème persiste merci de faire un ticket au support DOSI',
                  showConfirmButton: false,
                  timer: 5000
                });
              }.bind(this));
          },
        },
        errors: {checkboxFusion: '', checkbox: '', gestionnaire: '', commentaire: '', fusion: ''},
        user: [],
        disableExportExcel: true,
        searchData: [],
        excelData: [],
        affectationProlongationOnly: false,
        canMakeDpcCev: false,
      };
    },
    created() {
      this.$axios.defaults.baseURL = getBaseUrl();
      this.$axios.defaults.headers.common["Authorization"] = getIdToken() + " " + getAccessToken();
      // this.$axios.defaults.headers.common["Accept"] = "application/json";
      this.$axios.defaults.headers.common["Provider"] = getProvider();
    },
    watch: {
     selectedRows(newVal, oldVal) {
        // Handle changes in individual checkboxes
        if (newVal.length === 0) {
          this.indeterminate = false
          this.allSelected = false
        } else if (newVal.length === this.$refs.table.data.length) {
          this.indeterminate = false
          this.allSelected = true
        } else {
          this.indeterminate = true
          this.allSelected = false
        }
      },
      '$parent.modeVisualisation'(newVal, oldVal) {
        this.modeAuthorized();
      },
    },
    computed: {
      classObject: function () {
        return {
          'btn-disable': !this.findDossiers.length > 0,
        }
      },
      showAffect() {
        return type => {
          let canAutoAffecte = type === "autoAffecte" ? hasRule(rules.CAN_AUTO_AFFECTE) : false;
          // Dans le cas d'une recherche avec traitementId, on regarde si le gestionnaire a le traitement nécessaire pour l'autoAffectation
          if (canAutoAffecte && !isEmpty(this.$parent.traitementId)) {
            let userTraitementIds = getUserTraitementIds();
            canAutoAffecte = userTraitementIds.indexOf(parseInt(this.$parent.traitementId, 10)) > -1;
          }
          return (hasRule(rules.CAN_AFFECTE_DOSSIER) || hasRule(rules.CAN_AFFECTE_DOSSIER_ALL) || isResponsable() || canAutoAffecte) && (!isEmpty(this.$parent.traitementId) || !isEmpty(this.$parent.gestionnaire));
        }
      }
    },
    mounted() {
      // let columns = ['source', 'date_reception', 'dossier_type', 'siren', 'produit', 'nom', 'nb_pj', 'status', 'gestionnaire', 'delai', 'notes', 'action'];
      let columns = ['date_reception', 'source', 'date_affectation', 'dossier_type', 'siren', 'produit', 'nom', 'nb_pj', 'status', 'date_objectif', 'notes', 'action'];
      if (this.canDoAction()) {
        columns.push('selection')
      }
      this.columns = columns
      // On fait un watch sur les résultats de la recherche. Si résultat on s'occupe des couleurs de background
      this.$watch(
        () => {
            return this.$refs.table.data
        },
        (val) => {
          // On commence par enlever toutes les class
          for (let traitement of this.$parent.allTraitements) {
            for (let dossier of this.$refs.table.data) {
              let tr = document.getElementsByClassName('row_dossier_' + dossier.id + '_' + traitement.id)[0];
              if (tr) {
                tr.style.removeProperty('background-color');
              }
            }
          }
          if (val.length && this.$parent.onlyOneCritere) {
            // On s'occupe de rajouter les bonnes class
            let traitementId = null;
            for (let dossier of this.$refs.table.data) {
              if (isEmpty(this.$parent.traitementId)) {
                traitementId = this.getTraitementId(dossier);
              } else {
                traitementId = this.$parent.traitementId;
              }
              let tr = document.getElementsByClassName('row_dossier_' + dossier.id + '_' + traitementId)[0];
              tr.classList.add('color_traitement_' + traitementId);
            }

            // On modifie les couleurs en fonction des class
            if (isEmpty(this.$parent.traitementId)) {
              for (let traitement of this.$parent.allTraitements) {
                let rows = document.getElementsByClassName('color_traitement_' + traitement.id);
                for (let row of rows) {
                  row.style.backgroundColor = traitement.bg_color;
                }
              }
            }
          }
        }
      );
      this.modeAuthorized();

      this.$event.on('changeModeVisualisation', (modeVisualisation) => {
        this.$parent.modeVisualisation = modeVisualisation;
        // A voir s'il faut vider le tableau de résultat au changement de mode de visualisation (implique perte de la recherche)
        // if (!isEmpty(this.$refs.table)) {
        //   this.$refs.table.resetQuery();
        //   this.$parent.noSearch = 'noSearch';
        //   this.$refs.table.refresh();
        // }
      });
    },
    methods: {
      canSetDossierUrgent() {
        return hasRule(rules.CAN_SET_DOSSIER_URGENT) || isResponsable();
      },
      getFontColor(dossier) {
        let style = '';
        let traitementId = null;
        if (isEmpty(this.$parent.traitementId)) {
          traitementId = this.getTraitementId(dossier);
        } else {
          traitementId = this.$parent.traitementId;
        }
        let traitement = this.$parent.allTraitements.reduce((res, traitement) => {
          return parseInt(traitement.id,10) === parseInt(traitementId,10) ? traitement : res;
        },{});
        style = traitement ? 'color: ' + traitement.font_color + ';' : '';

        return style;
      },
      getIconSrc(type, dossier) {
        return getIconPostit(type, dossier);
      },
      hasTooltipDetailSinistre(row){
        if(!isEmpty(row.type) && row.type.groupe.toLowerCase() === 'ij'){
          if(row.date_debut_periode || row.date_fin_periode || row.montant_ij_ss){
            return true;
          }
        }
        return false;
      },
      modeAuthorized() {
        let modeAuthorized = ['monActiviteProd','monEquipeProd','monServiceProd','monEquipeManagement'];
        this.canShowActionBar = modeAuthorized.indexOf(this.$parent.modeVisualisation) > -1;

        return modeAuthorized.indexOf(this.$parent.modeVisualisation) > -1;
      },
      onLoaded() {
        // this.$store.commit('IS_LOADING', false);
      },
      toggleAll(checked) {
        this.selectedRows = checked ? this.$refs.table.data.map(item => {
          return item.id
        }) : []
      },
      buildQueryUrl(dossierIds, traitementId) {
        return {
                traitementId: traitementId,
                status: this.$parent.selectedStatus,
                sousStatus: this.$parent.selectedSousStatus,
                statusPrestij: this.$parent.selectedStatusPrestij,
                gest: this.$parent.gestionnaire,
                gestNom: this.$parent.gestionnaireNom,
                gestPrenom: this.$parent.gestionnairePrenom,
                bal: this.$parent.balId,
                nir: this.$parent.nir,
                dd: this.$parent.date_du,
                da: this.$parent.date_au,
                dsd : this.$parent.date_sinistre_du,
                dsa: this.$parent.date_sinistre_au,
                nom: this.$parent.nom,
                prenom: this.$parent.prenom,
                rar: this.$parent.rar,
                numeroEvenementNsi: this.$parent.numeroEvenementNsi,
                siren: this.$parent.siren,
                segment: this.$parent.selectedSegments,
                segmentCom: this.$parent.selectedSegmentsCommerciaux,
                delegations: this.$parent.selectedDelegations,
                oags: this.$parent.selectedOags,
                oaps: this.$parent.selectedOaps,
                team: this.$parent.selectedTeam,
                canal: this.$parent.selectedCanals,
                produit: this.$parent.selectedProduits,
                type: this.$parent.selectedTypes,
                statusTraite: this.$parent.statusTraite,
                basketId: this.$parent.basketId,
                alerte: this.$parent.alerte,
                page: this.$refs.table.page,
                limit: this.$refs.table.limit,
                modeVisualisation: this.$parent.modeVisualisation,
                seqDossiers: dossierIds,
                groupeSiren: this.$parent.selectedGroupSirens,
                campagnes: this.$parent.selectedCampagnes,
                dossierIds: this.$parent.dossierIds,
                typeUrgence: this.$parent.selectedTypesUrgences,
                fromDashboard: this.$parent.fromDashboard,
                contactEmail: this.$parent.contactEmail,
                regleCumul: this.$parent.regleCumul,
                nomBeneficiaire: this.$parent.nomBeneficiaire,
                nbDossierNir: this.$parent.nbDossierNir,
                exclureBpij: this.$parent.exclureBpij
              };
      },
      showDossier(dossier) {
        let dossierId = dossier.id;
        // let dossierIds = this.findDossiers.map((dossier) => dossier.id);
        let allDossierIds = this.findDossiers.map((dossier) => dossier.id);
        let dossierIds = [...new Set(allDossierIds)]
        let user = getUser();
        let userOags = user.profil_active[0].oags.map(oag => oag.code);
        let userOaps = user.profil_active[0].oaps.map(oap => oap.code);

        if (isEmpty(this.$parent.traitementId)) {
          this.$parent.traitementId = this.getTraitementId(dossier);
          this.$parent.selectedTraitementId = this.getTraitementId(dossier);
        }
        // console.log('dossier.oag',dossier.oag,user.profil_active[0].oags)
        if (isEmpty(this.$parent.traitementId)) {
          this.$swal({
            position: "top",
            type: "warning",
            title: "Attention !",
            text: 'Vous ne pouvez pas ouvrir ce dossier dans le mode de visualisation "Management"',
            showConfirmButton: false,
            timer: 3000
          })
        } else {
          let traitement = this.$parent.allTraitements.find(el => el.id === parseInt(this.$parent.traitementId,10));
          if (userOags.indexOf(dossier.oag) > -1  && userOaps.indexOf(dossier.oap) > -1 && (traitement.libelle_technique !== 'gestion_dc' || (traitement.libelle_technique === 'gestion_dc' && this.hasHabilitationDc()))) {
            let query = this.buildQueryUrl(dossierIds, this.$parent.traitementId);
            this.$router.push({
              path: '/espace-gestion/dossier/show/' + dossierId,
              query: query
            })
          } else {
            this.$swal({
              position: "top",
              type: "warning",
              title: "Attention !",
              text: 'Vous n\'avez pas les habilitations pour consulter ce dossier',
              showConfirmButton: false,
              timer: 3000
            })
          }
        }
      },
      getSrc(dossier) {
        if (!isEmpty(dossier)) {
          let dossierId = dossier.id;

          let allDossierIds = this.findDossiers.map((dossier) => dossier.id);
          let dossierIds = [...new Set(allDossierIds)]
          let user = getUser();
          let userOags = user.profil_active[0].oags.map(oag => oag.code);
          let userOaps = user.profil_active[0].oaps.map(oap => oap.code);
          let traitementId = this.$parent.traitementId;
          if (isEmpty(traitementId)) {
            traitementId = this.getTraitementId(dossier);
          }
          if (isEmpty(traitementId)) {
            return null;
          } else {
            let traitement = this.$parent.allTraitements.find(el => el.id === parseInt(traitementId,10));
            if (userOags.indexOf(dossier.oag) > -1 && userOaps.indexOf(dossier.oap) > -1 && (traitement.libelle_technique !== 'gestion_dc' || (traitement.libelle_technique === 'gestion_dc' && this.hasHabilitationDc()))) {
              let query = this.buildQueryUrl(dossierIds, traitementId);
              return {
                path: '/espace-gestion/dossier/show/' + dossierId,
                query: query
              }
            } else {
              return null;
            }
          }
        } else {
          return null;
        }
      },
      getSegmentGestion(dossier) {
        let response = 'n.d';
        if (dossier.siren) {
          if (dossier.siren.preference) {
            response = dossier.siren.preference.segment_gestion.libelle;
          }
        }
        return response;
      },
      getIndication(dossier) {
        let indication = ''
        if (dossier.siren && dossier.siren.preference) {
          if (dossier.siren.preference.has_dispense_bs && parseInt(dossier.siren.preference.status_prestij_id) === 5 && !dossier.siren.preference.has_subrogation) {
            indication = 'Disp BS/Déc'
          } else if (dossier.siren.preference.has_dispense_bs && parseInt(dossier.siren.preference.status_prestij_id) !== 5 && !dossier.siren.preference.has_subrogation) {
            indication = 'Disp BS'
          } else if (!dossier.siren.preference.has_dispense_bs && parseInt(dossier.siren.preference.status_prestij_id) === 5 && !dossier.siren.preference.has_subrogation) {
            indication = 'Disp Déc'
          } else if (dossier.siren.preference.has_dispense_bs && parseInt(dossier.siren.preference.status_prestij_id) === 5 && dossier.siren.preference.has_subrogation) {
            indication = 'Disp BS/Déc | subro'
          } else if (dossier.siren.preference.has_dispense_bs && parseInt(dossier.siren.preference.status_prestij_id) !== 5 && dossier.siren.preference.has_subrogation) {
            indication = 'Disp BS | subro'
          } else if (!dossier.siren.preference.has_dispense_bs && parseInt(dossier.siren.preference.status_prestij_id) === 5 && dossier.siren.preference.has_subrogation) {
            indication = 'Disp Déc | subro'
          } else if (!dossier.siren.preference.has_dispense_bs && parseInt(dossier.siren.preference.status_prestij_id) !== 5 && dossier.siren.preference.has_subrogation) {
            indication = 'subrogation'
          } else if (!dossier.siren.preference.has_dispense_bs && parseInt(dossier.siren.preference.status_prestij_id) !== 5 && !dossier.siren.preference.has_subrogation) {
            indication = ''
          }
        }

        return indication
      },
      getDelai(date) {
        moment.locale('fr')
        let today = moment()
        let momentDate = moment(date, 'YYYY-MM-DD hh:mm:ss')

        if (!momentDate.isValid()) {
          return '-'
        }
        let delai = today.diff(momentDate, 'days') < 2 ? today.diff(momentDate, 'days') + ' jour' : today.diff(momentDate, 'days') + ' jours'

        return delai
      },
      getEquipe(dossier) {
        // On commence par regarder si on n'est pas au statut "A Affecter" auquel cas on n'affiche rien pour éviter
        // de mettre le nom du gestionnaire précédement affecté pour le même traitement
        // (exemple deux demandes d'affiliation une fois la première traité il existe une ligne dossier_gestionnaire pour le traitement 4 existe et va ressortir même pour la 2eme qui est a affecter)
        let statusAAffecter = this.$parent.allStatus.reduce((res, status) => {
          return status.libelle_technique === 'a_affecter' ? status : res
        }, null);
        let statusTraitement = dossier.status.reduce((res, status) => {
          return parseInt(status.pivot.traitement_id, 10) === parseInt(this.$parent.traitementId, 10) ? status : res
        }, null)
        if (statusTraitement && statusAAffecter && statusAAffecter.id === statusTraitement.id) {
          return '-'
        }
        let equipeNames = '-';
        let gestionnaire = {equipes: []};

        for (let gest of dossier.gestionnaires) {
          if (parseInt(gest.pivot.traitement_id, 10) === parseInt(this.$parent.traitementId, 10)) {
            gestionnaire = gest
          }
        }

        for (let equipe of gestionnaire.equipes) {
          equipeNames = equipeNames === '-' ? equipe.libelle : equipeNames + '/' + equipe.libelle;
        }
        return equipeNames;
      },
      getGestionnaire(dossier) {
        // On commence par regarder si on n'est pas au statut "A Affecter" auquel cas on n'affiche rien pour éviter
        // de mettre le nom du gestionnaire précédement affecté pour le même traitement
        // (exemple deux demandes d'affiliation une fois la première traité il existe une ligne dossier_gestionnaire pour le traitement 4 existe et va ressortir même pour la 2eme qui est a affecter)
        let statusAAffecter = this.$parent.allStatus.reduce((res, status) => {
          return status.libelle_technique === 'a_affecter' ? status : res
        }, null);
        let traitementId = this.$parent.traitementId ? parseInt(this.$parent.traitementId, 10) : this.getDossierTypeTraitement(dossier);
        let statusTraitement = dossier.status.reduce((res, status) => {
          return parseInt(status.pivot.traitement_id, 10) === traitementId ? status : res
        }, null)
        if (statusTraitement && statusAAffecter && statusAAffecter.id === statusTraitement.id) {
          return '-'
        }
        let gestionnaire = {};
        for (let gest of dossier.gestionnaires) {
          if (parseInt(gest.pivot.traitement_id, 10) === traitementId) {
            gestionnaire = gest
          }
        }
        return gestionnaire.nom ? gestionnaire.nom.toUpperCase() + ' ' + gestionnaire.prenom : '-';
      },
      getLibelleTraitement(dossier,type) {
        let traitementId = this.$parent.traitementId ? parseInt(this.$parent.traitementId, 10) : this.getDossierTypeTraitement(dossier);
        let traitement = this.$parent.allTraitements.reduce((res, treatment) => {
          return parseInt(treatment.id, 10) === traitementId ? treatment : res
        }, null)
        if (traitement) {
          return type === 'court' ? traitement.libelle_court : traitement.libelle;
        }
        return '';
      },
      getTooltip(dossier) {
        let tooltip = ''

        for (let commentaireKey in this.commentairesOriginaux[dossier.id]) {
          tooltip = tooltip + this.commentairesOriginaux[dossier.id][commentaireKey].texte + '\n'
        }

        return tooltip
      },
      getStatus(dossier, type) {
        let response = ''
        let traitementId = this.$parent.traitementId ? parseInt(this.$parent.traitementId, 10) : this.getDossierTypeTraitement(dossier);
        for (let status of dossier.status) {
          if (parseInt(status.pivot.traitement_id, 10) === traitementId) {
            if (type === 'parent') {
              response = status.parent ? status.parent.libelle_bo : status.libelle_bo
            } else if (type === 'sousStatut') {
              response = status.parent ? status.libelle_bo : '-'
            }
          }
        }

        return response
      },
      getTraitementId(dossier) {
        let traitementId = '';
        if (!isEmpty(dossier.traitement_id)) {
          traitementId = dossier.traitement_id;
        } else {
          let hasTraitementNotEligible = false;
          // let hasTraitementNotEligible = getUser().profil_active[0].traitements.reduce((res,traitement) => {
          //   return res || traitement.type.toLowerCase() === 'secondaire' || (traitement.type.toLowerCase() === 'principale' && traitement.categorie.toLowerCase() !== 'production');
          // }, false);

          if (!hasTraitementNotEligible) {
            traitementId = this.getDossierTypeTraitement(dossier);
          }
        }

        return traitementId;
      },
      getDossierTypeTraitement(dossier) {
        let traitementId = '';

        let mainTreatment = getMainTreatmentBasedOnType(dossier, this.$parent.allTraitements);

        traitementId = mainTreatment.id;
        return traitementId;
      },
      fusion() {
        this.clearError()
        if (this.validateFusion()) {
          let self = this;
          this.$swal
            .fire({
              title: "Êtes-vous sûr?",
              text: "Voulez-vous vraiment fusionner ces dossiers ?",
              type: "warning",
              reverseButtons: true,
              showCancelButton: true,
              allowOutsideClick: false,
              cancelButtonColor: "#ff1744",
              confirmButtonText: "Annuler",
              cancelButtonText: "Fusionner"
            })
            .then(result => {
              if (!result.value) {
                let dataPost = {
                  dossierIds: this.selectedRows,
                  traitement_id: this.$parent.traitementId
                }
                this.$store.commit("IS_LOADING", true)
                this.$axios
                  .post("/espaceGestion/dossier/fusionner", dataPost)
                  .then(response => {
                    this.$store.commit("IS_LOADING", false);
                    this.$refs.table.refresh();
                    this.$event.emit('refreshDashboard');
                    this.selectedRows = [];
                    let textSwal = 'Fusion réalisée avec succès !';
                    let typeSwal = 'success';
                    let titleSwal = 'Succès';
                    let timeSwal = 5000;
                    if (!isEmpty(response.data.idppsNull)) {
                      typeSwal = 'warning';
                      titleSwal = 'Attention !!';
                      textSwal = 'Les dossiers suivants n\'ont pu être fusionnés car le N°PP NSI n\'est pas renseigné : ' + response.data.idppsNull.join(',');
                      timeSwal = 0;
                    }
                    self.$swal({
                      position: "top",
                      type: typeSwal,
                      title: titleSwal,
                      text: textSwal,
                      showConfirmButton: false,
                      timer: timeSwal
                    })
                })
                  .catch(function (error) {
                    self.$store.commit("IS_LOADING", false)
                    console.log(error)
                    let errorText = "Une erreur est survenue. Si le problème persiste, merci de faire un ticket au support DOSI."
                    if (error.response && error.response.status === 403) {
                      errorText = "Vous n'êtes pas autorisé à effectuer cette action"
                    }
                    if (error.response && error.response.status === 424) {
                      errorText = error.response.data.message
                    }
                    self.$swal({
                      position: "top",
                      type: "error",
                      title: "Attention !!",
                      text: errorText,
                      showConfirmButton: false,
                      timer: 5000
                    })
                  })
              }
            })
        }
      },
      validateFusion() {
        let error = false
        this.clearError()

        if (this.selectedRows.length <= 1) {
          error = true
          this.errors.checkboxFusion = 'Vous devez choisir au moins deux dossiers pour une fusion.'
        }

        // On vérifie si on peut fusionner les dossiers :
        // La fusion n'est possible que si :
        // - le NIR est identique ou il n'existe qu'un seul NIR et les autres sont vides
        // - le SIREN est identique ou il n'existe qu'un seul SIREN et les autres sont vides
        // - les dossiers sélectionnés sont de même type
        let selectedDossier = []
        for (let dossier of this.findDossiers) {
          if (this.selectedRows.indexOf(dossier.id) > -1) {
            selectedDossier.push(dossier)
          }
        }
        selectedDossier.sort((a, b) => {
          return a.id - b.id
        })

        let groupesDC = selectedDossier.reduce((res, item) => {
          if (item.type.groupe !== undefined && item.type.groupe === 'DC') {
            return res.indexOf(item.type.groupe) === -1 ? [...res, item.type.groupe] : res
          }
          return res
        }, [])
        if (groupesDC.length == 1) {
          let idpps = selectedDossier.reduce((res, item) => {
            if (item.id_pp || item.id_pp === null) {
              return res.indexOf(item.id_pp) === -1 ? [...res, item.id_pp] : res
            }
            return res
          }, []);
          let idppsWithNoNull = idpps.reduce((res, item) => { return isEmpty(item) ? res : [...res, item]},[]);
          const isNull = (currentValue) => currentValue === null;

          if (idppsWithNoNull.length > 1) {
            error = true
            this.errors.fusion = 'Les dossiers que vous avez sélectionnés pour la fusion n\'ont pas tous le même N°PP NSI.\n';
          } else if (idpps.every(isNull)) {
            error = true
            this.errors.fusion = 'Les dossiers que vous avez sélectionnés pour la fusion n\'ont pas de N°PP NSI.\n';
          }
          return !error
        }
        else {
          let sirens = selectedDossier.reduce((res, item) => {
            if (item.siren) {
              return res.indexOf(item.siren.siren) === -1 ? [...res, item.siren.siren] : res
            }
            return res
          }, [])
          if (sirens.length > 1) {
            error = true
            this.errors.fusion = 'Les dossiers que vous avez sélectionnés pour la fusion ne sont pas tous du même SIREN.\n'
          }
          let nirs = selectedDossier.reduce((res, item) => {
            if (item.nir) {
              return res.indexOf(item.nir) === -1 ? [...res, item.nir] : res
            }
            return res
          }, [])
          if (nirs.length > 1) {
            error = true
            this.errors.fusion = 'Les dossiers que vous avez sélectionnés pour la fusion n\'ont pas tous le même NIR.\n'
          }
          let types = selectedDossier.reduce((res, item) => {
            if (item.type.libelle !== undefined) {
              return res.indexOf(item.type.libelle) === -1 ? [...res, item.type.libelle] : res
            }
            return res
          }, [])
          if (types.length > 1) {
            error = true
            this.errors.fusion = 'Les dossiers que vous avez sélectionnés pour la fusion n\'ont pas tous le même Type.\n'
          }
          const typesTechniques = selectedDossier.reduce((res, item) => {
            if (item.type.libelle !== undefined) {
              return res.indexOf(item.type.libelle_technique) === -1 ? [...res, item.type.libelle_technique] : res;
            }
            return res;
          }, []);
          if (typesTechniques.includes('ij-bpij') || typesTechniques.includes('bpijo' || typesTechniques.includes('bpijp'))) {
            error = true;
            this.errors.fusion = 'Les dossiers que vous avez sélectionnés sont de type BPIJ, impossible de réaliser la fusion';
          }
          return !error
        }


      },
      setDossierUrgent() {
        if (this.validateCheckedCheckbox()) {
          let self = this;
          this.$swal
            .fire({
              title: "Êtes-vous sûr?",
              text: "Voulez-vous passer les dossiers sélectionnés en Urgences Directions ?",
              type: "warning",
              reverseButtons: true,
              showCancelButton: true,
              allowOutsideClick: false,
              cancelButtonColor: "#ff1744",
              confirmButtonText: "Confirmer",
              cancelButtonText: "Annuler"
            })
            .then(result => {
              if (result.value) {
                let dataPost = {
                  'dossierIds': this.selectedRows
                };
                this.$store.commit('IS_LOADING', true);
                this.$axios
                  .post('/espaceGestion/dossier/setUrgenceDirection', dataPost)
                  .then((response) => {
                    // console.log(response)
                    this.$store.commit('IS_LOADING', false);
                    this.selectedRows = [];
                    this.$refs.table.refresh();
                    this.$event.emit('refreshDashboard');
                    this.gestionnaireGestion = '';
                    this.gestionnairesGestion = [];
                    // console.log('response.data',response.data)
                    let html = '<div class="text-left">Passage de ' + response.data.message + ' dossiers en Urgences Directions réalisé avec succès.<br>';
                    html = html + '</div>';
                    self.$swal({
                      position: 'top',
                      type: 'success',
                      title: 'Confirmation',
                      html: html,
                      showConfirmButton: false,
                      timer: 0
                    });
                  })
                  .catch(function (error) {
                    console.log(error)
                    let textError = 'Une erreur est survenue, si le problème persiste merci de faire un ticket au support DOSI';
                    if (error.response.status === 400) {
                      textError = 'Vous devez choisir au moins un dossier';
                    }
                    if (error.response.status === 424) {
                      textError = error.response.data.message;
                    }
                    self.$store.commit('IS_LOADING', false);
                    self.$swal({
                      position: 'top',
                      type: 'error',
                      title: 'Attention !!',
                      text: textError,
                      showConfirmButton: false,
                      timer: 4000
                    });
                  });
              }
            });
        } else {
          this.$swal({
            position: 'top',
            type: 'error',
            title: 'Attention !!',
            text: 'Vous devez d\'abord sélectionner un ou plusieurs dossiers avant de pouvoir passer des dossiers en Urgences Directions',
            showConfirmButton: false,
            timer: 4000
          });
        }
      },
      editCommentaire(dossier) {
        this.commentairesGestion = dossier.commentaires_gestion
        this.dossierIdForCommentaire = dossier.id
        this.$refs['modal-commentaire'].show()
        // console.log('this.commentaires[this.dossierIdForCommentaire]',this.commentaires[this.dossierIdForCommentaire])
        // console.log('this.commentairesGestion',this.commentairesGestion)
      },
      saveCommentaire() {
        if (this.validateCommentaires()) {
          let self = this
          let dataPost = {
            'dossierId': this.dossierIdForCommentaire,
            'commentaireExistant': this.commentaires[this.dossierIdForCommentaire],
            'newCommentaireTexte': this.commentaireToAdd,
            'newCommentaireIsUrgent': this.isUrgentToAdd,
            'newCommentaireIsRelationClient': this.isRelationClientToAdd,
          }
          this.$store.commit('IS_LOADING', true)
          this.$axios
            .post('/espaceGestion/dossier/commentaire', dataPost)
            .then(response => {
              this.$store.commit('IS_LOADING', false)
              this.closeModal()
              this.$refs.table.refresh()
              self.$swal({
                position: "top",
                type: "success",
                title: "Succès !",
                text: 'Commentaire bien enregistré',
                showConfirmButton: false,
                timer: 3000
              })
            })
            .catch(function (error) {
              console.log(error)
              let textError = 'Une erreur est survenue, si le problème persiste merci de faire un ticket au support DOSI'
              if (error.response.status === 400) {
                textError = 'Vous devez saisir un commentaire'
              }
              self.$store.commit('IS_LOADING', false)
              self.$swal({
                position: 'top',
                type: 'error',
                title: 'Attention !!',
                text: textError,
                showConfirmButton: false,
                timer: 5000
              })
            })
        }
      },
      canDeleteCommentaire(commentaire) {
        let user = getUser();
        return !isEmpty(commentaire.gestionnaire) && (isResponsable() || parseInt(commentaire.gestionnaire.id,10) === parseInt(user.id,10));
      },
      deleteCommentaire(commentaire) {
        let self = this;
        let data = {};
        let dossier_id = commentaire.dossier_id;

        data.traitementId = this.$parent.traitementId;
        // console.log('this.$axios',this.$axios)
        this.$swal.fire({
          title: 'Êtes-vous sûr?',
          text: 'Voulez-vous vraiment supprimer ce commentaire ?',
          type: 'warning',
          reverseButtons: true,
          showCancelButton: true,
          cancelButtonColor:'#ff1744',
          confirmButtonText: 'Annuler',
          cancelButtonText: 'Supprimer',
        }).then((result) => {
          if (result.value !== true) {
            data.commentaireId = commentaire.id;
            data.dossierId = dossier_id;
            this.$store.commit('IS_LOADING', true);
            this.$axios
              .post('/espaceGestion/dossier/commentaire/delete',data)
              .then(response => {
                this.$store.commit('IS_LOADING', false);
                this.$swal({ position: 'top', type: 'success', title:'Suppression avec succès', text:'Le commentaire a bien été supprimé',showConfirmButton: false, timer: 3000});

                this.$refs.table.refresh()
                // on met à jour les commentaires affichés dans le modal
                this.commentairesGestion = response.data.commentaires;
              })
              .catch(function(error){
                console.log(error)
                self.$store.commit('IS_LOADING', false)
                self.$swal({ position: 'top', type: 'warning', title:'Attention !!', text:'Une erreur est survenue lors de la suppression du commentaire. Si le problème persiste, merci de faire un ticket au support DOSI.',showConfirmButton: false, timer: 5000})
              })
          }
        })
      },
      closeModal() {
        this.$refs['modal-commentaire'].hide()
        this.remiseAZero()
      },
      remiseAZero() {
        this.addComHidden = true
        this.commentaireToAdd = ''
        this.isUrgentToAdd = false
        this.commentairesGestion = []
        this.dossierIdForCommentaire = ''
        this.clearError()
        // Remise à réro des commentaires existants
        for (let dossierKey in this.commentairesOriginaux) {
          if (dossierKey === undefined) {
            continue
          }
          for (let commentaireKey in this.commentairesOriginaux[dossierKey]) {
            if (commentaireKey === undefined) {
              continue
            }
            this.commentaires[dossierKey][commentaireKey] = this.commentairesOriginaux[dossierKey][commentaireKey]
          }
        }
      },
      validateCommentaires() {
        let error = false
        for (let commentaireKey in this.commentaires[this.dossierIdForCommentaire]) {
          if (commentaireKey === undefined) {
            continue
          }
          if (this.commentaires[this.dossierIdForCommentaire][commentaireKey].texte === '') {
            error = true
            this.errors.commentaire = 'Vous ne pouvez pas enregistrer un commentaire vide'
          }
        }
        if (this.commentaireToAdd.trim() === '' && this.isUrgentToAdd === true) {
          error = true
          this.errors.commentaire = 'Vous ne pouvez pas enregistrer un commentaire vide'
        }

        if (this.commentaireToAdd.trim() === '' && this.isRelationClientToAdd === true) {
          error = true
          this.errors.commentaire = 'Vous ne pouvez pas enregistrer un commentaire vide'
        }
        return !error
      },
      canDoMerge() {
        let traitement = this.$parent.allTraitements.reduce((res, item) => {
          return item.id === parseInt(this.$parent.traitementId) ? item : res;
        }, {});
        let userTraitementIds = getUserTraitementIds();
        // A adapter lors de l'ajout d'un traitement
        // TODO : Voir s'il ne faut pas ajouter une notion de droit pour les traitements, pour que l'ajout d'un traitement n'entraine pas une modification du code
        return (traitement.libelle_technique === 'ij_gestion_prestation' || traitement.libelle_technique === 'gestion_inval' || traitement.libelle_technique === 'gestion_dc') && userTraitementIds.indexOf(traitement.id) > -1;
      },
      canAffecte(type) {
        let canAutoAffecte = type === "autoAffecte" ? hasRule(rules.CAN_AUTO_AFFECTE) : false;
        // Dans le cas d'une recherche avec traitementId, on regarde si le gestionnaire a le traitement nécessaire pour l'autoAffectation
        if (canAutoAffecte && !isEmpty(this.$parent.traitementId)) {
          let userTraitementIds = getUserTraitementIds();
          canAutoAffecte = userTraitementIds.indexOf(parseInt(this.$parent.traitementId, 10)) > -1;
        }
        return (hasRule(rules.CAN_AFFECTE_DOSSIER) || hasRule(rules.CAN_AFFECTE_DOSSIER_ALL) || isResponsable() || canAutoAffecte) && (!isEmpty(this.$parent.traitementId) || !isEmpty(this.$parent.gestionnaire))
      },
      launchAffectation(type) {
        if (this.validateCheckedCheckbox()) {
          if (type === 'affecte') {
            this.$refs['modal-affectation'].show();
          } else if (type === 'autoAffecte') {
            this.gestionnaireGestion = getUser().id;
            this.affecter();
          }
        } else {
          this.$swal({
            position: 'top',
            type: 'error',
            title: 'Attention !!',
            text: 'Vous devez d\'abord sélectionner un ou plusieurs dossiers avant de pouvoir faire une affectation',
            showConfirmButton: false,
            timer: 4000
          });
        }
      },
      closeModalAffectation() {
        this.$refs['modal-affectation'].hide()
        this.clearError()
        this.gestionnaireGestion = ''
        this.gestionnairesGestion = []
      },
      affecter() {
        if (this.validateDataAffectationGestion()) {
          let self = this;
          let currentTreatement = this.$parent.allTraitements.filter(traitement => {
            return (traitement.id === this.$parent.traitementId)
          })
          let textConfirm = "Voulez-vous affecter ce(s) dossier(s) à ce gestionnaire ?"
          if (!isEmpty(currentTreatement[0])) {
            textConfirm = "Voulez-vous affecter ce(s) dossier(s) avec le traitement " + currentTreatement[0].type + " : " + currentTreatement[0].libelle + " à ce gestionnaire ?"
          }
          let dataPost = {
                  'dossierIds': this.selectedRows,
                  'gestionnaireId': this.gestionnaireGestion,
                  'traitementId': this.$parent.traitementId,
                  'originalGestionnaireId': this.$parent.gestionnaire,
                  'affectationProlongationOnly': this.affectationProlongationOnly,
                  'for': 'count',
                  'typeDossierId': this.$parent.selectedTypes
                };
          // console.log('this.$parent.traitementId',this.$parent.traitementId)
          this.$store.commit('IS_LOADING', true);
          this.$axios
            .post('/espaceGestion/dossier/affectation', dataPost)
            .then((response) => {
              this.$store.commit('IS_LOADING', false);
              let texte = this.getTexteInfosAffectation(response, 'count', currentTreatement);
              let texteFinal = textConfirm + '<br>' + texte;
              this.$swal
                .fire({
                  title: "Êtes-vous sûr?",
                  html: texteFinal,
                  type: "warning",
                  reverseButtons: true,
                  showCancelButton: true,
                  allowOutsideClick: false,
                  cancelButtonColor: "#ff1744",
                  confirmButtonText: "Confirmer",
                  cancelButtonText: "Annuler"
                })
                .then(result => {
                  if (result.value) {
                    let dataPost = {
                      'dossierIds': this.selectedRows,
                      'gestionnaireId': this.gestionnaireGestion,
                      'traitementId': this.$parent.traitementId,
                      'originalGestionnaireId': this.$parent.gestionnaire,
                      'affectationProlongationOnly': this.affectationProlongationOnly,
                      'typeDossierId': this.$parent.selectedTypes
                    };
                    // console.log('this.$parent.traitementId',this.$parent.traitementId)
                    this.$store.commit('IS_LOADING', true);
                    this.$axios
                      .post('/espaceGestion/dossier/affectation', dataPost)
                      .then((response) => {
                        // console.log(response)
                        this.$store.commit('IS_LOADING', false);
                        this.selectedRows = [];
                        this.$refs.table.refresh();
                        this.$event.emit('refreshDashboard');
                        this.gestionnaireGestion = '';
                        this.gestionnairesGestion = [];
                        this.affectationProlongationOnly = false;
                        this.$refs['modal-affectation'].hide();
                        // console.log('response.data',response.data)
                        let texte = this.getTexteInfosAffectation(response, 'affectation', currentTreatement);
                        self.$swal({
                          position: 'top',
                          type: 'success',
                          title: 'Confirmation',
                          html: texte,
                          width: '42rem',
                          showConfirmButton: false,
                          timer: 0
                        });
                      })
                      .catch(function (error) {
                        console.log(error)
                        self.$store.commit('IS_LOADING', false);
                        let textError = 'Une erreur est survenue, si le problème persiste merci de faire un ticket au support DOSI';
                        if (error.response && error.response.status === 400) {
                          textError = 'Vous devez choisir au moins un dossier et séléctionner un gestionnaire';
                        }
                        if (error.response && error.response.status === 424) {
                          textError = error.response.data.message;
                        }

                        self.$swal({
                          position: 'top',
                          type: 'error',
                          title: 'Attention !!',
                          text: textError,
                          showConfirmButton: false,
                          timer: 4000
                        });
                      });
                  }
                });
            }).catch(function (error) {
                console.log(error)
                self.$store.commit('IS_LOADING', false);
                let textError = 'Une erreur est survenue, si le problème persiste merci de faire un ticket au support DOSI';
                if (error.response && error.response.status === 400) {
                  textError = 'Vous devez choisir au moins un dossier et séléctionner un gestionnaire';
                }
                if (error.response && error.response.status === 424) {
                  textError = error.response.data.message;
                }

                self.$swal({
                  position: 'top',
                  type: 'error',
                  title: 'Attention !!',
                  text: textError,
                  showConfirmButton: false,
                  timer: 4000
                });
              });
        }
      },
      getTexteInfosAffectation(response, context, currentTreatement) {
        let texte = context === 'count' ? '<div class="text-left">L\'affectation comprendra ' + response.data.message + ' dossiers' : '<div class="text-left">Affectation de ' + response.data.message + ' dossier(s) réalisée avec succès';
        let typeDossier = 'typeDossier';
        let texteArray = [];
        // console.log('currentTreatement',currentTreatement,currentTreatement.libelle_technique !== 'gestion_dbco')
        // On n'affiche pas d'info sup pour DBCO (sans ça les dossiers affectés sont comptabilisés en tant que prolong)
        if (isEmpty(currentTreatement[0]) || (!isEmpty(currentTreatement[0]) && currentTreatement[0].libelle_technique !== 'gestion_dbco' && currentTreatement[0].libelle_technique !== 'validation_dbco')) {

          if (response.data.nbDossierOuverture > 0) {
            typeDossier = ` ${response.data.nbDossierOuverture} dossier(s) ouverture`;
            texteArray.push(typeDossier)
          }
          if (response.data.nbDossierProlongation > 0) {
            typeDossier = ` ${response.data.nbDossierProlongation} dossier(s) prolongation`;
            texteArray.push(typeDossier)
          }
          if (response.data.nbDossierBpij > 0) {
            typeDossier = ` dont ${response.data.nbDossierBpij} dossier(s) BPIJ`;
            texteArray.push(typeDossier)
          }
          texteArray = texteArray.join(',')
        }
        // console.log('texteArray' + texteArray);
        if (!isEmpty(texteArray)) {
          texte = `${texte} (${texteArray})` + '.<br>';
        } else {
          texte = `${texte}` + '.<br>';
        }
        if (response.data.rejected) {
          let precision = context === 'count' ? 'ne pourront être affectés'  : 'n\'ont pas été affectés';
          texte = texte  + response.data.rejected + ` dossiers ` + precision + ` pour une des raisons suivantes :<br>
            <ul><li>Soit le gestionnaire destinataire n\'a pas le traitement nécessaire pour gérer ces dossiers.</li>
            <li>Soit vous avez choisi de n'affecter que des dossiers sans ouvertures et ceux-ci en contenaient</li></ul></div>`;
        } else {
          texte = texte + '</div>';
        }

        return texte;
      },
      desaffectation() {
        if (this.validateCheckedCheckbox()) {
          let self = this;
          this.$swal
            .fire({
              title: "Êtes-vous sûr?",
              text: "Voulez-vous désaffecter ce(s) dossier(s) ?",
              type: "warning",
              reverseButtons: true,
              showCancelButton: true,
              allowOutsideClick: false,
              cancelButtonColor: "#ff1744",
              confirmButtonText: "Confirmer",
              cancelButtonText: "Annuler"
            })
            .then(result => {
              if (result.value) {
                let dataPost = {
                  'dossierIds': this.selectedRows,
                  'traitementId': this.$parent.traitementId,
                  'originalGestionnaireId': this.$parent.gestionnaire,
                };
                // console.log('this.$parent.traitementId',this.$parent.traitementId)
                this.$store.commit('IS_LOADING', true);
                this.$axios
                  .post('/espaceGestion/dossier/desaffecter', dataPost)
                  .then((response) => {
                    // console.log(response)
                    this.$store.commit('IS_LOADING', false);
                    this.selectedRows = [];
                    this.$refs.table.refresh();
                    this.$event.emit('refreshDashboard');
                    this.gestionnaireGestion = '';
                    this.gestionnairesGestion = [];
                    // console.log('response.data',response.data)
                    let html = '<div class="text-left">Désaffectation de ' + response.data.message + ' dossiers réalisée avec succès.<br>';
                    if (response.data.rejected) {
                      html = html + response.data.rejected + ' dossiers n\'ont pas été désaffectés car leurs statuts ou celui des dossiers du même salarié ne le permet pas.<br>Voici la liste des dossiers non désaffectés : ';
                      for (let dossierId of response.data.dossierRejectedIds) {
                        if (response.data.dossierRejectedIds.indexOf(dossierId) === (response.data.dossierRejectedIds.length - 1)) {
                          html = html + dossierId;
                        } else {
                          html = html + dossierId + ', ';
                        }
                      }
                      html = html + '</div>';
                    }
                    self.$swal({
                      position: 'top',
                      type: 'success',
                      title: 'Confirmation',
                      html: html,
                      showConfirmButton: false,
                      timer: 0
                    });
                  })
                  .catch(function (error) {
                    console.log(error)
                    let textError = 'Une erreur est survenue, si le problème persiste merci de faire un ticket au support DOSI';
                    if (error.response.status === 400) {
                      textError = 'Vous devez choisir au moins un dossier';
                    }
                    if (error.response.status === 424) {
                      textError = error.response.data.message;
                    }
                    self.$store.commit('IS_LOADING', false);
                    self.$swal({
                      position: 'top',
                      type: 'error',
                      title: 'Attention !!',
                      text: textError,
                      showConfirmButton: false,
                      timer: 4000
                    });
                  });
              }
            });
        } else {
          this.$swal({
            position: 'top',
            type: 'error',
            title: 'Attention !!',
            text: 'Vous devez d\'abord sélectionner un ou plusieurs dossiers avant de pouvoir faire une désaffectation',
            showConfirmButton: false,
            timer: 4000
          });
        }
      },
      canDoAction() {
        // Rajouter des actions au fur et à mesure qu'on en développe
        let user = getUser();
        let matchingTreatment = false;
        for (let traitement of user.profil_active[0].traitements) {
          if (traitement.libelle_technique === 'ij_gestion_prestation' || traitement.libelle_technique === 'gestion_inval' || traitement.libelle_technique === 'gestion_dc' || traitement.libelle_technique === 'gestion_dbco') {
            matchingTreatment = true;
          }
        }
        // console.log('dans canDoAction',traitementFusionIds,this.$parent.allTraitements)
        return hasRule(rules.CAN_AFFECTE_DOSSIER) || hasRule(rules.CAN_AFFECTE_DOSSIER_ALL) || matchingTreatment;
      },
      async onSearchGestionnaireGestion(search) {
        let self = this
        const lettersLimit = 1

        this.noData = false
        if (search.length < lettersLimit) {
          this.gestionnairesGestion = []
          this.loadingGestionnaire = false
          return
        }
        this.loadingGestionnaire = true

        clearTimeout(this.timeoutId)
        this.timeoutId = setTimeout(async () => {
          this.$axios
            .get('/espaceGestion/gestionnaire/autocompleteRecherche?query=' + search + '&type=equipe')
            .then(response => {
              // console.log(response)
              this.loadingGestionnaire = false
              this.gestionnairesGestion = response.data
              if (!this.gestionnairesGestion.length) this.noData = true
            })
            .catch(function (error) {
              console.log(error)
              self.loadingGestionnaire = false
              self.$swal({
                position: 'top',
                type: 'error',
                title: 'Attention !!',
                text: 'Une erreur est survenue, si le problème persiste merci de faire un ticket au support DOSI',
                showConfirmButton: false,
                timer: 5000
              })
            })
        }, 500)
      },
      validateDataAffectationGestion() {
        let error = false
        this.clearError()

        error = !this.validateCheckedCheckbox()

        if (this.gestionnaireGestion === '' || this.gestionnaireGestion === null) {
          error = true
          this.errors.gestionnaire = 'Vous devez séléctionner un gestionnaire'
        }
        // console.log(this.gestionnaireGestion)
        return !error
      },
      validateCheckedCheckbox() {
        let error = false
        this.clearError()

        if (this.selectedRows.length === 0) {
          error = true
          this.errors.checkbox = 'Vous devez choisir au moins un dossier.'
        }

        return !error
      },
      clearError() {
        this.errors.checkbox = ''
        this.errors.checkboxFusion = ''
        this.errors.gestionnaire = ''
        this.errors.commentaire = ''
        this.errors.fusion = ''
      },
      formatNumber(num) {
        return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1 ");
      },
      formatDate(textDate) {
        let date = textDate !== null ? moment(textDate).format('DD/MM/YY') : "-";
        return date;
      },
      formatDateHeure(textDate) {
        let date = textDate !== null ? new Date(textDate).toLocaleString("fr-FR") : "-";
        return date;
      },
      formatNir(textNir) {
        if (textNir !== null && textNir !== '') {
          let displayNir = ''

          displayNir = textNir.substring(0, 1) + ' ' + textNir.substring(1, 3) + ' ' + textNir.substring(3, 5) + ' ' + textNir.substring(5, 7) + ' ' + textNir.substring(7, 10) + ' ' + textNir.substring(10, 13) + ' ' + textNir.substring(13, 15)
          return displayNir
        } else {
          return textNir
        }
      },
      getTimestamp() {
        let date = new Date;
        let day = date.getDate().toString().length === 1 ? '0' + date.getDate().toString() : date.getDate().toString();
        let month = (date.getMonth() + 1).toString().length === 1 ? '0' + (date.getMonth() + 1).toString() : (date.getMonth() + 1).toString();
        let year = date.getFullYear().toString();

        return day + '_' + month + '_' + year;
      },
      getInfosSegmentProduit(dossier) {
        let produit = dossier.famille_produit ? dossier.famille_produit.libelle : 'n.d';
        return this.getSegmentGestion(dossier) + '<br><span style="color: #F96706;">' + produit + '</span>';
      },
      getInfosStatus(dossier) {
        return '<b>' + this.getStatus(dossier, 'parent') + '</b><br>' + this.getStatus(dossier, 'sousStatut');
      },
      getDateAffectation(dossier) {
        let gestionnaire = ""
        if (this.$parent.onlyOneCritere) {
          gestionnaire = dossier.gestionnaires.find(gest => gest.pivot.traitement_id === dossier.traitement_id);
        } else {
          let traitementId = this.$parent.traitementId ? parseInt(this.$parent.traitementId, 10) : this.getDossierTypeTraitement(dossier);
          gestionnaire = dossier.gestionnaires.find(gest => gest.pivot.traitement_id === traitementId);
        }
        if (isEmpty(gestionnaire)) { return "" }

        return '<b>' + this.formatDate(gestionnaire.pivot.created_at) + '</b><br>' + this.getInfosAffectation(dossier)
      },
      getInfosAffectation(dossier) {
        let currentTreatement = this.$parent.allTraitements.find(traitement => {
          return (traitement.id === this.$parent.traitementId)
        });
        if (!isEmpty(currentTreatement)) {
          let currentStatus = dossier.status.find(status => status.pivot.traitement_id === currentTreatement.id);

          if (!isEmpty(currentStatus) && currentTreatement.libelle_technique === 'validation_dbco' && currentStatus.libelle_technique === 'a_affecter') {
            let traitementDbco = this.$parent.allTraitements.find(traitement => traitement.libelle_technique === 'gestion_dbco');
            let gestionnaireDbco = dossier.gestionnaires.find(gest => gest.pivot.traitement_id === traitementDbco.id);
            return gestionnaireDbco.prenom+ ' ' + gestionnaireDbco.nom + '<br><span class="text-primary">Gestion DBCO</span>';
          }
        }

        return this.getGestionnaire(dossier) + '<br><span class="text-primary">';
      },
      getStatusLibelleTechnique(dossier, type) {
        let response = ''
        let traitementId = this.$parent.traitementId ? parseInt(this.$parent.traitementId, 10) : this.getDossierTypeTraitement(dossier);
        for (let status of dossier.status) {
          if (parseInt(status.pivot.traitement_id, 10) === traitementId) {
            if (type === 'parent') {
              response = status.parent ? status.parent.libelle_technique : status.libelle_technique
            } else if (type === 'sousStatut') {
              response = status.parent ? status.libelle_technique : '-'
            }
          }
        }

        return response
      },
      getStatusEnAttenteDpc() {
        let statusEnAttenteDpcId = null
        for (let status of this.$parent.allStatus) {
          if (status.libelle_technique === 'en_attente') {
            for (let statusEnAttente of status.sous_statuts) {
              if (statusEnAttente.libelle_technique === 'en_attente_dpc') {
                statusEnAttenteDpcId = statusEnAttente.id;
              }
            }
          }
        }
        return statusEnAttenteDpcId
      },
      getInfosDateObjectif(dossier) {
        if (!isEmpty(dossier.type) && dossier.type.groupe.toLowerCase() == 'dc') {
          if (!isEmpty(dossier.decompteJours)) {
            if (-7 <= dossier.decompteJours && dossier.decompteJours <= -3) {
              return '<b>' + this.formatDate(dossier.dateObjectif) + '</b><br><i class="fa fa-exclamation-triangle" style="color:#4dbd74" aria-hidden="true"></i><span style="color:#4dbd74"><b> ' + dossier.decompteJoursText + '</b></span>'
            } else if ((-2 <= dossier.decompteJours && dossier.decompteJours < 0) || dossier.decompteJours >= 0) {
              return '<b>' + this.formatDate(dossier.dateObjectif) + '</b><br><i class="fa fa-exclamation-triangle" style="color:#f64846" aria-hidden="true"></i><span style="color:#f64846"><b> ' + dossier.decompteJoursText + '</b></span>'
            } else {
              return '<b>' + this.formatDate(dossier.dateObjectif) + '</b><br>' + dossier.decompteJoursText
            }
          }
        }
      },
      getInfosType(dossier) {
        let type = dossier.type && dossier.type.libelle_technique === 'dbco' ? dossier.type.libelle+' ('+dossier.dbco_type+')' : (dossier.type ? dossier.type.libelle : 'n.d');

        return type;
      },
      isTreatment(libelle_technique) {
        let treatment = _.find(this.$parent.allTraitements, (element) => element.libelle_technique === libelle_technique );
        return isEmpty(treatment) ? false : parseInt(this.$parent.traitementId,10) === treatment.id
      },
      hasManageDossier() {
        let self = this;
        const dataPost = {
          dossiers_ids: this.selectedRows,
          gestionnaire_id: this.gestionnaireGestion,
        }
        this.$axios.post('/espaceGestion/gestionnaire/hasOagOapHabilitation', dataPost)
          .then(response => {
            if (response.data.errors.length > 0) {
              this.$swal({
                position: "top",
                type: "error",
                title: "Attention !!",
                html: `<ul>${response.data.errors.map(message => `<li>${message}</li>`)}</ul>`,
                showConfirmButton: false,
                timer: 4500
              });
            } else {
              if (this.isTreatment('ij_module_prevoyance')) {
                this.$axios.post('/espaceGestion/gestionnaire/hasNsiUserActeur', dataPost)
                  .then(response => {
                    if (response.data.errors.length > 0) {
                      this.$swal({
                        position: "top",
                        type: "error",
                        title: "Attention !!",
                        html: `<ul>${response.data.errors.map(message => `<li>${message}</li>`)}</ul>`,
                        showConfirmButton: false,
                        timer: 4500
                      });
                    } else {
                      this.affecter();
                    }
                  })
                  .catch(function (error) {
                    console.log(error)
                    self.$swal({
                      position: 'top',
                      type: 'error',
                      title: 'Attention !!',
                      text: 'Une erreur est survenue, si le problème persiste merci de faire un ticket au support DOSI',
                      showConfirmButton: false,
                      timer: 4000
                    });
                  });
              } else {
                this.affecter();
              }
            }
            // else {
            //   this.affecter();
            // }
          })
          .catch(function (error) {
            console.log(error)
            self.$swal({
              position: 'top',
              type: 'error',
              title: 'Attention !!',
              text: 'Une erreur est survenue, si le problème persiste merci de faire un ticket au support DOSI',
              showConfirmButton: false,
              timer: 4000
            });
          });
      },
      exportResultat() {
        if (this.searchData.length !== 0) {
          let self = this;
          let name = 'export_recherche_dossiers_' + this.getTimestamp();
          let ext = 'csv';
          this.searchData.forExport = true;
          this.$store.commit('IS_LOADING', true);
          // this.$axios.defaults.baseURL = 'https://recette-middle-extract.chorum.fr/api';
          if (!isEmpty(process.env.VUE_APP_MIDDLE_EXTRACT_URL)) {
            this.$axios.defaults.baseURL = process.env.VUE_APP_MIDDLE_EXTRACT_URL;
          }
          this.$axios.get('/espaceGestion/dossier/export-resultat', {params: this.searchData, responseType: 'blob'})
            .then(response => {
              this.$store.commit('IS_LOADING', false);
              downloadFile(response, name, ext);
            })
            .catch(function (error) {
              console.log(error)
              self.$store.commit('IS_LOADING', false);
              self.$swal({
                position: 'top',
                type: 'error',
                title: 'Attention !!',
                text: 'Une erreur est survenue pendant la génération de l\'export, si le problème persiste merci de faire un ticket au support DOSI',
                showConfirmButton: false,
                timer: 5000
              });
            });
        }
      },
      importDpcCev() {
        this.$store.commit('IS_LOADING', true);
        this.$axios.get('/espaceGestion/dossier/import-dpc-cev')
          .then(response => {
            this.$store.commit('IS_LOADING', false);
            if (response.data.import === undefined) {
              this.$swal({
                position: 'top',
                type: 'warning',
                title: 'Notification',
                text: 'Il n\'y a pas de documents à importer',
                showConfirmButton: false,
                timer: 5000
              });
            }
            else {
              this.$swal({
                position: 'top',
                type: 'success',
                title: 'Importation',
                text: 'Les documents ont été importés',
                showConfirmButton: false,
                timer: 5000
              });
            }
          })
          .catch(function (error) {
            console.log(error)
            self.$store.commit('IS_LOADING', false);
            self.$swal({
              position: 'top',
              type: 'error',
              title: 'Attention !!',
              text: 'Une erreur est survenue pendant l\'import des documents, si le problème persiste merci de faire un ticket au support DOSI',
              showConfirmButton: false,
              timer: 5000
            });
          });
      },
      hasHabilitationDc() {
        let user = getUser();
        let allowedTraitement = [];
        allowedTraitement = user.profil_active[0].traitements.filter(traitement => (traitement.libelle_technique === 'gestion_dc' || traitement.libelle_technique === 'qualification_courrier' || traitement.libelle_technique === 'affiliation' || traitement.libelle_technique === 'ij_correction_cotisations' || traitement.libelle_technique === 'ij_correction_contrat' || traitement.libelle_technique === 'appui_expert_entreprise' || traitement.libelle_technique === 'blocage_cotisations_contentieux'));

        return allowedTraitement.length > 0;
      },
      cantEditFicheDC,
    }
  };
</script>

<style>
  tr.VueTables__row td {
    line-height: 25px;
    padding: 0 0.75rem;
  }

  .IZ-select__input input {
    font-size: 0.9rem;
  }

  .hasError {
    border-radius: 5px;
  }

  .bg-white {
    background-color: #FFFFFF;
  }

  .tooltip.b-tooltip.pre-formatted .tooltip-inner {
    white-space: pre-line;
    max-width: 100% !important;
  }

  .tooltip.b-tooltip.pre-formatted {
    max-width: 100%;
  }

  tr td.tooltip-cell {
    padding: 0;
  }

  tr td.tooltip-cell > div span {
    display: inline-block;
    width: 100%;
    padding: 0 0 0 0.75rem;
  }

  .ul-tooltip {
    padding: 0;
    list-style: none;
    margin-bottom: 0;
  }

  .green {
    color: #28a745;
  }

  .VueTables__sort-icon {
    float: none;
    position: absolute;
    right: 0.25rem;
  }

  .sort-top .VueTables__sort-icon {
    top: 0.75rem;
  }

  .sort-bottom .VueTables__sort-icon {
    bottom: 0.75rem;
  }

  .sort-middle .VueTables__sort-icon {
    bottom: 40%;
  }

  .min-width-nir {
    min-width: 175px;
  }

  .btn-disable {
    cursor: not-allowed;
    pointer-events: none;
    color: #c0c0c0;
    background-color: #ffffff;
  }

  .dossier-prioritaire-urgences-directions, .relance-decompte-2jours {
    color: #fff;
    background-color: #f86c6b;
  }

  .relance-decompte-7jours {
    color: #fff;
    background-color: #4dbd74;
  }

  .dossier-prioritaire-lignes-rouges {
    color: #fff;
    background-color: #ff8800;
  }

  .dossier-prioritaire-fiche-tel {
    color: #fff;
    background-color: #ff7fe9;
  }

  .dossier-prioritaire-mog {
    color: #fff;
    background-color: purple;
  }

</style>
